"use strict";

angular.module("customer")
.component("unitOfMeasureQuantity", {
    bindings: {
        quantity: "=",
        catalogEntry: "=",
        catalogEntryVariant: "=",
        shouldShowSuggestedOrderMultiplier: "<?",
        ignoreAutoSave: "<?",
        ignoreValidation: "<?",
        vendor: "<",
        isReturn: "=",
        isInventoryReturn: "<?",
        isCustomDiscount: "<?"
    },
    templateUrl: require("./quantity.component.html"),
    controller: function($scope, StocksService, CartItemService, PatternService) {
        var _this = this;
        this.quantity = parseFloat(this.quantity);
        var initialQuantity = this.quantity || 0;
        $scope.isTouchOptimized = false;
        this.removeOrderMultiplierMention = true;

        this.getLengthClass = function() {
            return StocksService.getLengthClass(this.quantity);
        };

        this.isOrderedButtonDisabled = function() {
            return false;
        };

        this.isQuantityChanged = function() {
            return initialQuantity !== this.quantity;
        };

        this.getErrorClass = function() {
            var pattern = PatternService.preciseWeightGreaterThanZero;
            var isQuantityValid = true;
            if (!this.ignoreValidation) {
                isQuantityValid = pattern.exec(this.quantity);
            }

            return {
                'quantity-error': !isQuantityValid,
                'value-changed': this.isQuantityChanged(),
                'value-unchanged': !this.isQuantityChanged(),
                'disabled': this.isOrderedButtonDisabled()
            };
        };

        this.saveQuantity = function(quantity) {
            if (this.ignoreAutoSave) {
                return;
            }

            var promise;
            if (this.isInventoryReturn) {
                promise = CartItemService.saveInventoryReturnUnitOfMeasureQuantity(
                    this.catalogEntry, this.catalogEntryVariant, quantity, this.vendor
                );
            }
            else if (this.isReturn) {
                promise = CartItemService.saveReturnUnitOfMeasureQuantity(
                    this.catalogEntry, this.catalogEntryVariant, quantity, this.vendor
                );
            }
            else if (this.isCustomDiscount) {
                promise = CartItemService.saveDiscountedUnitOfMeasureQuantity(
                    this.catalogEntry, this.catalogEntryVariant, quantity, this.vendor, null, this.catalogEntry.custom_discounted_price
                );
            } else {
                promise = CartItemService.saveOrderedUnitOfMeasureQuantity(
                    this.catalogEntry, this.catalogEntryVariant, quantity, this.vendor
                );
            }

            promise.then(function onSuccess() {
                _this.quantity = quantity;
            });
        };
    }
});



//////////////////
// WEBPACK FOOTER
// ./customer/app-core/ordered-quantity/unit-of-measure-quantity.component.js
// module id = 807
// module chunks = 0